/* eslint-env browser */

'use strict';

var Tag = require('./Tag');

/**
 * Netx semantic editor
 * @constructor
 * @extends Tag
 */
var Semantic = Tag.extend('Semantic', {
	/**
	 * @memberof Semantic.prototype
	 * @desc show editor and initialize select2
	 * @override Tag.prototype
	 */
	showEditor: function() {
		var self        = this,
			columnProps = this.event.columnProperties;

		setTimeout(function() {
			// Show
			self.el.style.display = 'inline-block';
			if (columnProps.semanticTypeId) {
				// Get autcomplete plugin
				var autocomplete = window.Netx.autocomplete.get('semanticObjects', { plugin: 's2', semanticObjectTypeId: columnProps.semanticTypeId, multiple: true }, null);
				// Init select2
				if (typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.select2 !== 'undefined') {
					window.jQuery(self.input).select2(window._.extend(autocomplete.options, { width: '100%' }));
					if (typeof self.toSet !== 'undefined') {
						window.jQuery(self.el).find('.select2-search__field').focus().val(self.toSet).trigger('keyup');
						delete self.toSet;
					}
				}
			} else {
				console.error('semanticTypeId not provided for semantic attribute');
			}
		}, 50);
	}
});

module.exports = Semantic;
